import { AlertAction, AlertType } from "../../ShellCommon/Controls/alert/alert";

export interface LogDetail {
  title: string;
  displayText: string;
  uId?: string;
  alertType: AlertType;
  alertActions?: AlertAction[];
  hideCloseButton?: boolean;
  onClose?: () => any;
}

export const logViewComponentOptions: ng.IComponentOptions = {
  templateUrl: "../ServiceDesk/sdDirectives/LogView.html",
  bindings: {
    logItems: "="
  }
};
